import type { FC, ReactNode } from 'react'

interface NpvMarkProps {
    className?: string
}

/** nine points on a ring, the top one larger: the home ring in one glyph */
const POINTS: Array<[number, number]> = [
    [16, 5],
    [23.07, 7.57],
    [26.83, 14.09],
    [25.53, 21.5],
    [19.76, 26.34],
    [12.24, 26.34],
    [6.47, 21.5],
    [5.17, 14.09],
    [8.93, 7.57]
]

export const NpvMark: FC<NpvMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            className={className}
            viewBox='0 0 32 32'
            width='32'
            height='32'
            aria-hidden='true'
            focusable='false'
        >
            {POINTS.map(([cx, cy], i) => (
                <circle
                    key={`${cx}-${cy}`}
                    cx={cx}
                    cy={cy}
                    r={i === 0 ? 3.1 : 2.05}
                    fill='currentColor'
                    opacity={i === 0 ? 1 : 0.62}
                />
            ))}
        </svg>
    )
}
